__turbopack_context__.v({
  "content-container": "content-container-module-scss-module__aiwALW__content-container",
  "content-container--wide": "content-container-module-scss-module__aiwALW__content-container--wide",
  "content-container__content": "content-container-module-scss-module__aiwALW__content-container__content",
  "content-container__content--wide": "content-container-module-scss-module__aiwALW__content-container__content--wide",
});
